export default __webpack_public_path__ + "static/media/cif-ir.b4804554.svg";